module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group col-xs-12",
    class: {
      'has-error': this.validation && this.validation.$error
    }
  }, [_c('div', {
    staticClass: "has-feedback"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOption),
      expression: "selectedOption"
    }],
    ref: "select",
    staticClass: "form-control",
    attrs: {
      "id": 'select' + _vm.name,
      "disabled": _vm.loading
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedOption = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.updateValue],
      "blur": _vm.blur
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "id": "optionDefault"
    },
    domProps: {
      "value": undefined
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm._l((_vm.options), function(option, index) {
    return _c('option', {
      attrs: {
        "id": 'option' + index
      },
      domProps: {
        "value": option
      }
    }, [_vm._v("\n        " + _vm._s(option.name) + "\n      ")])
  })], 2), _vm._v(" "), (_vm.loading) ? _c('span', {
    staticClass: "form-control-feedback padding-right-15"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-refresh glyphicon-refresh-animate"
  })]) : _vm._e(), _vm._v(" "), (_vm.required) ? _c('span', {
    staticClass: "glyphicon glyphicon-asterisk form-control-feedback padding-right-15",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.required) ? _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(required)")]) : _vm._e()]), _vm._v(" "), (!_vm.loading && _vm.validation && _vm.validation.$error) ? _c('div', {
    staticClass: "help-block small",
    attrs: {
      "role": "alert"
    }
  }, [(_vm.requiredError) ? _c('span', [_vm._v("The field is required")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58e5c1c3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/inputs/InputSelect.vue
// module id = 659
// module chunks = 5